import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Product } from '@features/product/interfaces/product.interface';
import { WishListService } from '@features/user/services/wisthlist.service';
import { faHeart, faStar } from '@fortawesome/free-solid-svg-icons';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'fc-product-item',
  templateUrl: './product-item.component.html',
  styleUrls: ['./product-item.component.css'],
})
export class ProductItemComponent implements OnInit {
  @Input() product: Product = {} as Product;
  @Input() showStockProgressBar: boolean = false;
  productImgPath: string = '';
  stockProgressWidth: number = 70;

  faStar = faStar;
  faHeart = faHeart;

  constructor(
    private wishlistService: WishListService,
    private messageService: MessageService,
    private router: Router
  ) {}

  ngOnInit(): void {
    if (this.product.image_path.medium.includes('https://')) {
      this.productImgPath = this.product.image_path.medium;
    }
    // fix in future; not possible to count like this;
    // this.stockProgressWidth =
    //   (this.product.remaining_stock ? this.product.remaining_stock : 0 / 100) *
    //   100;
  }

  onAddToWishlist() {
    if (this.product.on_wishlist) {
      this.wishlistService.removeFromWishlist(this.product.slug).subscribe({
        next: (res) => {
          this.product.on_wishlist = false;
        },
        error: (error) => {
          this.product.on_wishlist = true;
          this.messageService.clear();
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: error.error.message,
          });
        },
      });
    } else {
      this.product.on_wishlist = true;
      this.wishlistService.addToWishlist(this.product.slug).subscribe({
        next: (res) => {
          this.product.on_wishlist = true;
        },
        error: (error) => {
          this.product.on_wishlist = false;
          this.messageService.clear();
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: error.error.message,
          });
        },
      });
    }
  }
  handleProductImgError() {
    this.productImgPath = 'assets/images/product/default-product.webp';
  }
}
